import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CurrencyType} from './currency-type.model';
import * as CurrencyTypeActions from './currency-type.actions';

export const currencyTypeFeatureKey = 'currencyType';

export interface State extends EntityState<CurrencyType> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CurrencyType> = createEntityAdapter<CurrencyType>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CurrencyTypeActions.addCurrencyType,
    (state, action) => adapter.addOne(action.CurrencyType, state)
  ),
  on(CurrencyTypeActions.upsertCurrencyType,
    (state, action) => adapter.upsertOne(action.CurrencyType, state)
  ),
  on(CurrencyTypeActions.addCurrencyTypes,
    (state, action) => adapter.addMany(action.CurrencyTypes, state)
  ),
  on(CurrencyTypeActions.upsertCurrencyTypes,
    (state, action) => adapter.upsertMany(action.CurrencyTypes, state)
  ),
  on(CurrencyTypeActions.updateCurrencyType,
    (state, action) => adapter.updateOne(action.CurrencyType, state)
  ),
  on(CurrencyTypeActions.updateCurrencyTypes,
    (state, action) => adapter.updateMany(action.CurrencyTypes, state)
  ),
  on(CurrencyTypeActions.deleteCurrencyType,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CurrencyTypeActions.deleteCurrencyTypes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CurrencyTypeActions.loadCurrencyTypes,
    (state, action) => adapter.setAll(action.CurrencyTypes, state)
  ),
  on(CurrencyTypeActions.clearCurrencyTypes,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
